export var comparisonWidget = () => {
    // comparison widget: autocomplete on input fields with ujs - abort request when another is initiated
    let xhr_local;
    let product_a = document.querySelector('input#product_a');
    if(product_a) {
        product_a.addEventListener("ajax:beforeSend", (event) => {
            const [xhr] = event.detail;
            if (xhr_local) xhr_local.abort();
            xhr_local = xhr;
        });
        product_a.addEventListener("ajax:success", (event) => {
            xhr_local = null;
        });
    }

    if($('#product_a_toggle').find('.product-link').length) {
        $('#product_b_toggle').html('<i class="fas fa-spinner fa-spin"></i>');
        let initialProductA = $('#product_a_toggle').find('.product-link');
        initialProductA.click();
        initialProductA.attr('href', '#');
    }

    $('input#product_a').keyup(function() { $(this).change() });
    $('#product_a_results').on('click', '.product-link', function() {
        $('#product_b_toggle').addClass('btn-light disabled').html('<i class="fas fa-spinner fa-spin"></i>');
        setProductSelect($(this), '#product_a_toggle');
        $('#comparison-url').attr('href', '#').addClass('disabled');
    });

    $('#product_b_results').on('click', '.product-link', function(e) {
        e.preventDefault();
        setProductSelect($(this), '#product_b_toggle');
        let comparisonUrl = $(this).data('comparison-url');
        $('#comparison-url').attr('href', comparisonUrl).removeClass('disabled');
    });

    // autocomplete for comparison product
    $('input#product_b').keydown(function() {
        let value = $(this).val().toLowerCase();
        let results = $('#product_b_results').find('.dropdown-item');
        results.removeClass('d-none');
        results.each( function() {
            let result = $(this);
            if(!(result.find('.product-name').attr('title').toLowerCase().includes(value))) result.addClass('d-none');
        });
    });

    function setProductSelect(product, toggleElement) {
        let selectedProduct = product.children().clone();
        $(toggleElement).html(selectedProduct).removeClass('btn-light');
        // $(toggleElement).append('<i class="fal fa-circle-chevron-down ms-auto"></i>');
        if(!$(toggleElement).parents('.comparison-card').hasClass('vertical')) {
            $(toggleElement).parents('.comparison-card').css('padding', '1.5em');
        }
    }

    $('#product_a_toggle, #product_b_toggle').click(function () {
        let dropdown = $(this).data('bs-target');
        $(dropdown).find('input').focus();
    });
}
